import { ModelInstance, BaseModel, ToFrontHook, ToBackHook } from './util';
import { TournamentTeam } from './tournament-team';

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    sort: 'sort',
    tournament_stage_id: 'tournamentStageId',
    tournament_round_id: 'tournamentRoundId',
    division_id: 'divisionId',
  }
})
export class TournamentGroup extends BaseModel {
  id: number;
  name: string;
  sort: number;
  tournamentStageId: number;
  tournamentRoundId: number;
  divisionId: number;
  teams: TournamentTeam[];

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
